import Head from 'next/head';
import Link from 'next/link';
import FeatureCard from '../../../components/feature-card/feature-card';
import Layout from '../../../components/layouts/layout';
import { addApolloState, initializeApollo } from '../../../lib/apolloClient';
import fetchTeachers from '../../../lib/queries/fetchTeachers';
import useResponsive from '../../../lib/useResponsive';
import styles from './teachers.module.scss';
import { orderBy } from 'lodash';

export default function AboutTeacher({ teachers }) {
  const { isDesktop } = useResponsive();

  return (
    <Layout logoType="big" title="Our Teachers">
      <Head>
        <title>Teachers - The Sacred Fig</title>
        <meta name="description" content="Most Top list yoga teacher training in Bali and Portugal." />
      </Head>
      <div className={styles.container}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: isDesktop ? 'space-between' : 'space-around',
          }}
        >
          {teachers?.map((teacher, i) => (
            <Link href={`/about/teachers/${teacher.slug}`} key={i}>
              <div style={{ cursor: 'pointer' }}>
                <FeatureCard
                  feature={{
                    subtitle: teacher.name,
                    description: teacher.short_description,
                    media: [teacher.featured_image],
                  }}
                  mediaHeight={isDesktop ? 580 : 480}
                  style={{
                    width: isDesktop ? 400 : 330,
                    minHeight: isDesktop ? 700 : 650,
                    cursor: 'pointer',
                  }}
                ></FeatureCard>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query({
    query: fetchTeachers,
  });

  const teachers = orderBy(data.teachers, ['order'], ['asc']);

  return addApolloState(apolloClient, {
    props: { teachers },
    revalidate: 1,
  });
}
